import React, { useEffect, useState } from 'react';
import '../styles/newsDetail.css';

export default function NewsDetail({ item, onBack, bucketUrl }) {
  const [details, setDetails] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    fetch(`${bucketUrl}${item.folder}/data.json?v=${Date.now()}`)
      .then(res => res.json())
      .then(data => setDetails(data))
      .catch(err => console.error('Failed to fetch detail data:', err));
  }, [item, bucketUrl]);

  useEffect(() => {
    // Add a slight delay before showing the content with transition
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`news-detail-container ${visible ? 'visible' : ''}`}>
      <button className="back-button" onClick={onBack}>Back to News</button>

      {details ? (
        <>
          <img
            src={`${bucketUrl}${item.folder}/${encodeURIComponent(details.thumbnail)}`}
            alt={details.title}
            className="news-detail-image"
          />
          <h2 className="news-detail-title">{details.title}</h2>
          <div className="news-detail-content">
            {details.content.map((paragraph, idx) => (
              <p key={idx}>{paragraph}</p>
            ))}
          </div>
        </>
      ) : (
        <div className="loading-text">Loading news details...</div>
      )}
    </div>
  );
}
